<template>
  <v-card elevation="0" class="mt-4 data-table-controls">
    <v-data-table
      ref="aggregatesDataTable"
      :headers="headers"
      :items="filteredAggregatesTableData"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :custom-sort="customSort"
      disable-pagination
      hide-default-footer
      elevation="0"
    >
      <template #body="{ items }">
        <tbody v-for="(coach) in items" :key="(coach.name).replace(/\s+/g, '-') + '-coach-row'" :data-key="coach.name.replace(/\s+/g, '-') + '-coach-row'">
        <template v-if="coach.agents.length>0">
          <tr>
            <td class="expand-col">
              <v-btn icon @click="toggleCoach(coach)" color="blue darken-2" style="width">
                <v-icon>{{ expandedCoaches.includes(coach.name) ? "mdi-chevron-down" : "mdi-chevron-right" }}</v-icon>
              </v-btn>
            </td>

            <td class="item-stats-btn"><a class="no-underline" href="#" @click.prevent="openGuidance({ user_id: coach.user_id, agent_id: 0, query: {}})" :title="coach.user_id">{{ coach.name }}</a></td>
            <td>&nbsp;</td>
            <td class="number-col" v-highlight-on-change><a class="no-underline" href="#" @click.prevent="openGuidance({ user_id: coach.user_id, agent_id: 0, query: { guidance_task_search_text: '' }})">{{ coach.task_summary.task_count }}</a></td>
            <td class="number-col" v-highlight-on-change><a class="no-underline" href="#" @click.prevent="openGuidance({ user_id: coach.user_id, agent_id: 0, query: { guidance_task_search_text: 'status:new' }})">{{ coach.task_summary.tasks_new }}</a></td>
            <td class="number-col" v-highlight-on-change><a class="no-underline" href="#" @click.prevent='openGuidance({ user_id: coach.user_id, agent_id: 0, query: { guidance_task_search_text: "status:\"in progress\"" }})'>{{ coach.task_summary.tasks_in_progress }}</a></td>
            <td class="number-col" v-highlight-on-change><a class="no-underline" href="#" @click.prevent="openGuidance({ user_id: coach.user_id, agent_id: 0, query: { guidance_task_search_text: 'status:closed' }})">{{ coach.task_summary.tasks_closed }}</a></td>
            <td class="v-bar"></td>
            <td class="number-col" v-highlight-on-change><a class="no-underline" href="#" @click.prevent="openGuidance({ user_id: coach.user_id, agent_id: 0, query: { guidance_task_search_text: 'status:disputed' }})">{{ coach.task_summary.tasks_disputed }}</a></td>
            <td class="number-col" v-highlight-on-change><a class="no-underline" href="#" @click.prevent="openGuidance({ user_id: coach.user_id, agent_id: 0, query: { guidance_task_search_text: 'status:overdue' }})">{{ coach.task_summary.tasks_overdue }}</a></td>
            <td class="number-col" v-highlight-on-change><a class="no-underline" href="#" @click.prevent="openGuidance({ user_id: coach.user_id, agent_id: 0, query: { guidance_task_search_text: 'status:unread' }})">{{ coach.task_summary.tasks_unread }}</a></td>
            <td class="v-bar"></td>
            <td class="number-col" v-highlight-on-change>{{ coach.adjusted }}</td>
            <td class="number-col" v-highlight-on-change>{{ coach.task_summary.session_count }}</td>
            <td class="number-col" v-highlight-on-change>{{ formatDateTime(coach.task_summary.latest_session) }}</td>
        </tr>
        </template>
        <template v-else>
          <tr class="no-tasks-row">
            <td class="expand-col">
                <v-icon>&ndash;</v-icon>
            </td>

            <td><a class="no-underline" href="#" @click.prevent="openGuidance({ user_id: coach.user_id, agent_id: 0, query: {}})" :title="coach.user_id">{{ coach.name }}</a></td>
            <td colspan="12">
              <v-alert type="warning" dense class="mt-1 mb-1">
                No tasks have been created yet. Proceed by clicking your name to the left.
              </v-alert>
            </td>
          </tr>
        </template>

          <!-- Agent rows, shown only when coach is expanded -->
        <template v-if="expandedCoaches.includes(coach.name)">
          <tr
            v-for="(agent) in coach.agents"
            :key="coach.name.replace(/\s+/g, '-') + '-' + agent.name.replace(/\s+/g, '-') + '-agent-row'"
            :data="coach.name.replace(/\s+/g, '-') + '-' + agent.name.replace(/\s+/g, '-') + '-agent-row'"
          >
            <!-- Empty cell where the expand icon was -->
            <td></td>

            <!-- Rest of columns, aligning with the same headers -->
            <td class="agent-cell">
              <v-tooltip bottom :attach="false">
                <template v-slot:activator="{ on }">
                  <a
                      class="no-underline"
                      href="#"
                      @click.prevent="openGuidance({ user_id: coach.user_id, agent_id: agent.agent_id, query: {}})"
                      target="_blank"
                      rel="noopener"
                      v-on="on"
                      :title="agent.agent_id"
                  >
                    {{ agent.name }}
                  </a>
                </template>
                <dl>
                  <dt style="border-bottom: 1px dotted #fff;">TEAMS</dt>
                  <dd v-for="(team, index) in agent.teams" :key="index">{{ team.team_name }}</dd>
                </dl>
              </v-tooltip>
            </td>
            <td class="text-center scorecard-col">
              <v-menu
                open-on-hover
                offset-y
                close-on-content-click
                transition="fade-transition"
                content-class="sc-menu-bg"
                rounded="8"
              >
                <template #activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="cursor-pointer"
                    color="blue darken-2"
                  >
                    mdi-order-bool-ascending-variant
                  </v-icon>
                </template>
                <v-list dense>
                  <v-list-item
                    v-for="sc in agent.scorecards.slice().sort((a, b) => a.scorecard_name.localeCompare(b.scorecard_name) * (sortDesc ? -1 : 1))"
                    :key="sc.scorecard_id"
                    @click="openScorecardTab({ user_id: coach.user_id, agent_id: agent.agent_id, scorecard_id: sc.scorecard_id } )"
                  >
                    <v-list-item-title>
                      {{ sc.scorecard_name }} ({{ sc.scorecard_id }})
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
            <td class="number-col" v-highlight-on-change><a class="no-underline" href="#" @click.prevent="openGuidance({ user_id: coach.user_id, agent_id: agent.agent_id, query: { guidance_task_search_text: '' }})">{{ agent.task_summary.task_count }}</a></td>
            <td class="number-col" v-highlight-on-change><a class="no-underline" href="#" @click.prevent="openGuidance({ user_id: coach.user_id, agent_id: agent.agent_id, query: { guidance_task_search_text: 'status:new' }})">{{ agent.task_summary.tasks_new }}</a></td>
            <td class="number-col" v-highlight-on-change><a class="no-underline" href="#" @click.prevent='openGuidance({ user_id: coach.user_id, agent_id: agent.agent_id, query: { guidance_task_search_text: "status:\"in progress\"" }})'>{{ agent.task_summary.tasks_in_progress }}</a></td>
            <td class="number-col" v-highlight-on-change><a class="no-underline" href="#" @click.prevent="openGuidance({ user_id: coach.user_id, agent_id: agent.agent_id, query: { guidance_task_search_text: 'status:closed' }})">{{ agent.task_summary.tasks_closed }}</a></td>
            <td class="v-bar"></td>
            <td class="number-col" v-highlight-on-change><a class="no-underline" href="#" @click.prevent="openGuidance({ user_id: coach.user_id, agent_id: agent.agent_id, query: { guidance_task_search_text: 'status:disputed' }})">{{ agent.task_summary.tasks_disputed }}</a></td>
            <td class="number-col" v-highlight-on-change><a class="no-underline" href="#" @click.prevent="openGuidance({ user_id: coach.user_id, agent_id: agent.agent_id, query: { guidance_task_search_text: 'status:overdue' }})">{{ agent.task_summary.tasks_overdue }}</a></td>
            <td class="number-col" v-highlight-on-change><a class="no-underline" href="#" @click.prevent="openGuidance({ user_id: coach.user_id, agent_id: agent.agent_id, query: { guidance_task_search_text: 'status:unread' }})">{{ agent.task_summary.tasks_unread }}</a></td>
            <td class="v-bar"></td>
            <td class="number-col" v-highlight-on-change>{{ agent.adjusted }}</td>
            <td class="number-col" v-highlight-on-change>{{ agent.task_summary.session_count }}</td>
            <td class="number-col" v-highlight-on-change>{{ formatDateTime(agent.task_summary.latest_session) }}</td>
          </tr>
        </template>
        </tbody>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>

import moment from "moment"
export default {
  name: "AggregatesTable",
  components: {},
  props: {
    aggregatesTableDataSource: {
      type: Array,
      required: true
    },
    search: {
      type: String,
      required: true
    },
    collapsed: {
      type: Boolean,
      required: true
    },
    expanded: {
      type: Boolean,
      required: true
    },
    aggregateRow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading: false,
      loadingTimeout: null,
      expandedCoaches: [],
      // The columns for both coach and agent rows
      headers: [
        { text: "", value: "expand", width: "40px", sortable: false },
        { text: "Name", value: "name",  },
        { text: "Scorecard", value: "scorecard", sortable: false },
        { text: "Total", value: "task_summary.task_count", align: "right", class: "pr-0" },
        { text: "New", value: "task_summary.tasks_new", align: "right", class: "pr-0" },
        { text: "In-Progress", value: "task_summary.tasks_in_progress", align: "right", class: "pr-0" },
        { text: "Closed", value: "task_summary.tasks_closed", align: "right", class: "pr-0" },
        { text: "", align: "right", class: "header-v-bar", sortable: false },
        { text: "Disputed", value: "task_summary.tasks_disputed", align: "right", class: "pr-0" },
        { text: "Overdue", value: "task_summary.tasks_overdue", align: "right", class: "pr-0" },
        { text: "Unread", value: "task_summary.tasks_unread", align: "right", class: "pr-0" },
        { text: "", align: "right", class: "header-v-bar", sortable: false },
        { text: "Adjusted", value: "adjusted", align: "right", class: "pr-0" },
        { text: "Guidance Sessions", value: "task_summary.session_count", align: "right", class: "pr-0" },
        { text: "Last Guidance Session", value: "last_coaching_session", align: "right", sortable: false }
      ],
      sortBy: 'name',
      sortDesc: false,
    }
  },
  methods: {
    formatDateTime(date) {
      return (date) ? moment.utc(date).local().format('MMM D, YYYY h:mm A') : "—"
    },
    toggleCoach(coach) {
      const index = this.expandedCoaches.indexOf(coach.name)
      if (index >= 0) {
        // Remove (collapse)
        this.expandedCoaches.splice(index, 1)
      } else {
        // Add (expand)
        this.expandedCoaches.push(coach.name)
      }
    },
    openGuidance(scope) {
      let query = scope.query
      let path = (scope.user_id===0) ? "/task-summary-all/" : "/task-summary/"
      path += scope.user_id
      // if(scope.user_id>0) path += scope.user_id
      if(scope.agent_id===0) path += "/agents/"
      else path += "/agent/" + scope.agent_id
      this.$router.push({ path: path, query: query }).catch(err => {})
    },
    openScorecardTab(item) {
      let query = new URLSearchParams(this.$route.query).toString()
      let path = "/scorecards-v2/" + item.scorecard_id + "/dynalabels/0/agents/" + item.agent_id + "/calls?" + query
      window.open(path, '_blank')
    },
    sleep(ms) {
      // gives the UI time to update the spinner - slick way of employing setTimeout
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async expandAll() {
        const coachNames = this.filteredAggregatesTableData.map(c => c.name);
        // expand cascade - lets the user know something is happening
        for (const name of coachNames) {
          if (!this.expandedCoaches.includes(name)) {
            this.expandedCoaches.push(name);
            await this.sleep(75);
          }
        }
        await this.$nextTick();
        requestAnimationFrame(() => {
          if (this.aggregateRow) {
            this.$emit('agg-expand-all-finished');
          } else {
            this.$emit('expand-all-finished');
          }
        });
    },

    async collapseAll() {
        const namesToRemove = [...this.expandedCoaches];
        // collapse cascade - lets the user know something is happening
        for (const name of namesToRemove) {
          const idx = this.expandedCoaches.indexOf(name);
          if (idx !== -1) {
            this.expandedCoaches.splice(idx, 1);
          }
          await this.sleep(75);
        }
        await this.$nextTick();
        requestAnimationFrame(() => {
           if (this.aggregateRow) {
            this.$emit('agg-collapse-all-finished');
          } else {
            this.$emit('collapse-all-finished');
          }
        });
    },
    setExpandedCoaches(prop) {
      this.expandedCoaches = prop
    },
    customSort(items, sortBy, sortDesc,) {
      let sortDir = 1
      if (sortDesc && sortDesc.length > 0) sortDir = sortDesc[0] ? -1 : 1
      return items
        .slice()
        .sort((a, b) => {
          const aVal = this.getSortValue(a, sortBy[0])
          const bVal = this.getSortValue(b, sortBy[0])

          if (typeof aVal === 'string' && typeof bVal === 'string') {
            return aVal.localeCompare(bVal) * sortDir
          }

          if (aVal < bVal) return -1 * sortDir
          if (aVal > bVal) return 1 * sortDir
          return 0
        })
        .map(coach => ({
          ...coach,
          agents: coach.agents
            .slice()
            .sort((a, b) => {
              const aVal = this.getSortValue(a, sortBy[0])
              const bVal = this.getSortValue(b, sortBy[0])

              if (typeof aVal === 'string' && typeof bVal === 'string') {
                return aVal.localeCompare(bVal) * sortDir
              }

              if (aVal < bVal) return -1 * sortDir
              if (aVal > bVal) return 1 * sortDir
              return 0
            }),
        }))
    },
    getSortValue(obj, key) {
      if (typeof key !== 'string') return null

      if (key === 'name' && obj.lastname && obj.firstname) {
        const lastname = (obj.lastname || '').toString().trim()
        const firstname = (obj.firstname || '').toString().trim()
        return `${firstname.toLowerCase()} ${lastname.toLowerCase()}`
      }

      const parts = key.split('.')
      const value = parts.reduce((o, k) => (o && o[k] !== undefined ? o[k] : null), obj)
      return (value === null || value === undefined)
        ? -Infinity
        : typeof value === 'string'
          ? value.toLowerCase()
          : value
    },
  },
  computed: {
    filteredAggregatesTableData() {
      const sortKey = this.sortBy
      const sortDir = this.sortDesc ? -1: 1
      const toExpand = []
      let coaches = this.aggregatesTableDataSource.slice()
      if (this.search) {
        const q = this.search.toLowerCase()
        coaches = coaches
          .map(coach => {
            const coachHits = coach.name.toLowerCase().includes(q)
            const matchingAgents = coach.agents.filter(a =>
              a.name.toLowerCase().includes(q)
            )
            if (coachHits || matchingAgents.length) {
              if (!coachHits && matchingAgents.length) {
                toExpand.push(coach.name)
              }
              return {
                ...coach,
                agents: coachHits ? coach.agents : matchingAgents
              }
            }
            return null
          })
          .filter(Boolean)
      }

      const sortedCoaches = coaches
        .sort((a, b) => {
          const aV = this.getSortValue(a, sortKey)
          const bV = this.getSortValue(b, sortKey)
          return aV < bV ? -1 * sortDir : aV > bV ? 1 * sortDir : 0
        })
        .map(coach => ({
          ...coach,
          agents: coach.agents
            .slice()
            .sort((a, b) => {
              const aV = this.getSortValue(a, sortKey)
              const bV = this.getSortValue(b, sortKey)
              if (sortKey === 'name' && typeof aV === 'string') {
                return aV.localeCompare(bV) * sortDir
              }
              return aV < bV ? -1 * sortDir : aV > bV ? 1 * sortDir : 0
            })
        }))
      const fullySorted = sortedCoaches.map(coach => ({
        ...coach,
        agents: coach.agents.map(agent => ({
          ...agent,
          scorecards: agent.scorecards
            .slice()
            .sort((x, y) =>
              x.scorecard_name.localeCompare(y.scorecard_name) * sortDir
            )
        }))
      }))
      if (this.search) {
        this.setExpandedCoaches(toExpand)
      }

      this.$emit((this.aggregateRow) ? "agg-filtered-table-updated" : "filtered-table-updated", fullySorted.length + fullySorted.reduce((sum, coach) => sum + coach.agents.length, 0))
      return fullySorted
    }
  },
  watch: {
    collapsed: "collapseAll",
    expanded: "expandAll"
  }
}

</script>

<style scoped>

.data-table-controls {
  border-radius: 8px !important;
  background-color: rgba(1, 106, 175, 0.05);
}

.expand-col {
  width: 2rem;
  text-align: center;
}

.scorecard-col {
  width: 2rem;
}

.number-col {
  text-align: right;
  white-space: nowrap;
}

.agent-cell {
  padding-left: 2rem !important;
}

.v-bar {
  position: relative;
  padding-right: 0 !important;
}

.v-bar::before {
  content: "";
  position: absolute;
  right: 0; /* Offset the bar by 2rem from the left */
  top: 0;
  bottom: 0;
  border-right: 1px solid rgba(1, 106, 175, 0.25);
}

::v-deep .header-v-bar {
  border-right: 1px solid rgba(1, 106, 175, 0.25);
}

.no-underline {
  text-decoration: none;
}

.no-tasks-row td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.highlight {
  animation: highlight-animation 1s ease-out;
}

@keyframes highlight-animation {
  from { background-color: #fb8c00; }
  to { background-color: transparent; }
}

::v-deep .v-btn.v-btn--disabled {
  display: inline-flex !important;
  opacity: 1;
  pointer-events: none;
}

.item-stats-btn {
  width: 200px; 
  max-width:200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}


</style>
